/**
 * Stand-in imagery for a learning card that has no picture of its own.
 *
 * The fallback ladder on every learning surface is:
 *   the thing's OWN image  ->  a related real image  ->  one of these  ->  stripes
 *
 * A topic with no uploaded picture borrows its first course's cover; a course
 * with no cover lands straight here. These photos are self-hosted under
 * `public/learning/placeholders/` (see CREDITS.txt) rather than hotlinked, so a
 * tenant page never depends on a third-party CDN.
 *
 * Chosen by POSITION, deterministically — the same card keeps the same photo
 * across renders and reloads, and two cards side by side do not repeat until
 * the pool wraps. Never random: a placeholder that changes on every paint reads
 * as a bug.
 *
 * These are DECORATION, not data. The moment a real cover or topic picture is
 * uploaded it wins, and nothing here is ever presented as the tenant's own
 * photograph of a specific course.
 */
const POOL_SIZE = 8;

export function learningPlaceholder(index: number): string {
  const n = ((Math.trunc(index) % POOL_SIZE) + POOL_SIZE) % POOL_SIZE;
  return `/learning/placeholders/${String(n + 1).padStart(2, '0')}.jpg`;
}
